<h1 class="grotesk-regular pb-4 mb-4 page-title">{{ pageTitle }}</h1>
<app-inline-menu [tabs]="tabs"></app-inline-menu>
<!-- <nav class="nav nav-pills flex-column flex-sm-row tab-container mt-4">
	<div *ngFor="let tab of tabs"
		(click)="setSelectedTab(tab.tabText)"
		class="d-flex flex-column flex-grow-1 tab">
		<span [ngClass]="[tab.isSelected ? '' : 'tab-selected ']"
			class="tab-text">
			{{ tab.tabText }}
		</span>
		<div [ngClass]="[tab.isSelected ? 'visible' : 'invisible']"
			class="tab-selector"></div>
	</div>
</nav> -->
<ng-container [ngSwitch]="selectedTab.tabId">
	<ng-container *ngFor="let tab of tabs">
		<div *ngSwitchCase="tab.tabId">
			<ng-content [select]="tab.tabId"></ng-content>
		</div>
	</ng-container>
</ng-container>
